import type { ChangeRequestRegisterWithUserFieldsRow } from '@risksmart-app/drizzle/src/dto';
import type { GetChangeRequestsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { StrictMappedGraphQLSelection } from 'src/utils';

/**
 * Maps the slim tRPC register rows back to the legacy GraphQL query shape.
 * The display-only `parentOwners` field is derived from the concrete parent
 * relations by `useLabelledFields`; it is not part of the GraphQL selection.
 * The user-scoped owner list arrives separately from the repository's grant
 * lookup, so this mapper no longer needs the obsolete raw relation.
 */
export const mapChangeRequestRegisterRowsToGraphQl = (
  rows: ChangeRequestRegisterWithUserFieldsRow[]
): StrictMappedGraphQLSelection<GetChangeRequestsQuery> => ({
  change_request: rows.map((item) => ({
    ...item,
    currentUserOwnerList: item.currentUserOwnerList ?? [],
    responses: item.responses.flatMap((response) =>
      response.approver ? [{ ...response, approver: response.approver }] : []
    ),
    parent: item.parent
      ? {
          ...item.parent,
          documentFile: item.document_file
            ? {
                Version: item.document_file.Version,
                parent: item.document_file.parent,
              }
            : null,
          acceptance: item.acceptance,
          risk: item.risk,
          control: item.control,
          action: item.action,
          issue_assessment: item.issue_assessment,
        }
      : null,
  })),
});
